<button (click)="close('Pressed close button')" class="modal-close"></button>
<h4
  class="modal-title"
  i18n="Download Exception|The title of an exception modal @@exceptionModalTitle"
>
  Automatic download is not supported
</h4>
<div class="modal-content">
  <p
    class="modal-intro"
    i18n="Download Exception|A message we show when the browser can't automatically donwload a generated file @@exceptionModalIntro"
  >
    We noticed that automatic downloading is not supported in your browser.
    Please click below to download the generated csv file.
  </p>
</div>
<div class="modal-footer">
  <button
    (click)="close('Pressed OK button')"
    class="o-button o-button--default"
    i18n="Button| Cancel Button @@buttonCancel"
  >
    Cancel
  </button>
  <a
    [href]="getDataUrl(true)"
    (click)="close('Pressed OK button')"
    class="o-button o-button--success"
    [attr.download]="data.filename"
    i18n="Button|Button to download a file @@buttonDownloadFile"
    >Download File</a
  >
</div>
